import { ReferralReward } from '../consumer/consumer.types';
import { convertDateToNeedFormat } from '../../utils/convertDateHandlers';

export const formatTrigger = (trigger: string) => (trigger === 'TOPUP' ? 'Top-up' : 'Subscription');

export const formatTokens = (reward: ReferralReward) =>
  `+${reward.referrerTokens} / +${reward.inviteeTokens}`;

/** When the reward was settled, and by whom when a support user did it by hand */
export const formatDecided = (reward: ReferralReward) => {
  if (!reward.decidedAt) return '-';
  const decidedAt = convertDateToNeedFormat({ date: reward.decidedAt, format: 'datetime' });
  return reward.decidedByName ? `${decidedAt}, ${reward.decidedByName}` : decidedAt;
};
